import FormStepTypes from "constants/FormStepTypes";

const STEP_TO_ANALYTICS_NAME: Record<string, string> = {
  [FormStepTypes.ORGANISATION]: "Organisation",
  [FormStepTypes.SCHEDULE]: "Schedule",
  [FormStepTypes.PACKING_LIST]: "Packing List",
  [FormStepTypes.SERVICE]: "Service",
  [FormStepTypes.PROVIDER]: "Provider",
  [FormStepTypes.CONFIRMATION]: "Confirmation",
  // V2-style keys (used by field-path section resolution for dashboard parity)
  "request-form.organisation": "Organisation",
  "request-form.schedule": "Schedule",
  "request-form.packingList": "Packing List",
  "request-form.service": "Service",
  "request-form.provider": "Provider",
};

const SPECIAL_SECTION_NAMES: Record<string, string> = {
  confirmation: "Confirmation",
  header: "Header",
  unknown: "Unknown",
};

/** Maps v1 step / section keys to human-readable names for PostHog. */
export function toAnalyticsSectionName(sectionKey: string): string {
  return STEP_TO_ANALYTICS_NAME[sectionKey] ?? SPECIAL_SECTION_NAMES[sectionKey] ?? sectionKey;
}
